import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Outlet } from 'react-router-dom';

import WalletBalanceButton from '../account/WalletBalanceButton';
import { useSession } from '../session/SessionContext';
import Brand from '../ui/Brand';
import { brand } from '../theme';

export default function AppLayout() {
  const { session, signOut } = useSession();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: brand.canvas,
      }}
    >
      <Box
        component="header"
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          bgcolor: 'rgba(255,251,245,.92)',
          backdropFilter: 'blur(8px)',
          borderBottom: `1px solid ${brand.hairline}`,
        }}
      >
        <Box
          sx={{
            maxWidth: 1100,
            mx: 'auto',
            px: { xs: 2.25, sm: 4 },
            py: { xs: 1.5, md: 0 },
            minHeight: { md: 68 },
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
          }}
        >
          <Brand size={30} />

          <Box
            sx={{
              ml: 'auto',
              display: 'flex',
              alignItems: 'center',
              gap: { xs: 1, sm: 1.75 },
            }}
          >
            {session ? <WalletBalanceButton /> : null}
            {session ? (
              <Typography
                variant="body2"
                sx={{
                  color: brand.muted,
                  display: { xs: 'none', sm: 'block' },
                }}
              >
                {session.email}
              </Typography>
            ) : null}
            {session ? (
              <Button
                size="small"
                variant="outlined"
                onClick={signOut}
                sx={{ flex: 'none', borderRadius: '10px' }}
              >
                Sign out
              </Button>
            ) : null}
          </Box>
        </Box>
      </Box>

      <Box
        component="main"
        sx={{
          flex: 1,
          width: '100%',
          maxWidth: 616,
          mx: 'auto',
          px: { xs: 2.25, sm: 3.5 },
          py: { xs: 2.5, sm: 4.5 },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
